var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    {
      staticClass: "logged-in",
      class: {
        "theme-pickstar": _vm.clientName === "Pickstar",
      },
      attrs: { id: "header" },
    },
    [
      _c("div", { staticClass: "header-bar" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c(
            "div",
            { staticClass: "header-bar__container" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                _vm.logoComponent,
                {
                  tag: "component",
                  staticClass: "client-logo",
                  class: {
                    "client-logo--aoc": _vm.clientName === "AOC",
                  },
                  style: !_vm.$vlastMode ? "border: none" : "",
                  attrs: { href: _vm.logoLink },
                },
                [
                  _c("img", {
                    staticStyle: { "max-height": "100px" },
                    attrs: { src: _vm.logoSrc },
                  }),
                ]
              ),
              _vm._v(" "),
              !_vm.$whitelabel && _vm.$vlastMode
                ? _c(
                    "div",
                    { staticClass: "header-bar__logo" },
                    [
                      _c("vlast-logo-full", {
                        staticClass: "vlast-logo vlast-logo--full",
                        attrs: {
                          fill: _vm.clientConfig.colours.brand_vlast_text,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "header-bar__ui" },
                [
                  _vm._l(_vm.ctaButtons, function (ctaButton, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "margin-l-1" },
                      [
                        ctaButton && ctaButton.view
                          ? _c(
                              "router-link",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  tag: "button",
                                  to: { name: ctaButton.view },
                                },
                              },
                              [
                                ctaButton.icon
                                  ? _c("i", {
                                      staticClass: "fa",
                                      class: ctaButton.icon,
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  " " +
                                    _vm._s(ctaButton.label) +
                                    "\n            "
                                ),
                              ]
                            )
                          : ctaButton
                          ? _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { href: ctaButton.link },
                              },
                              [
                                ctaButton.icon
                                  ? _c("i", {
                                      staticClass: "fa",
                                      class: ctaButton.icon,
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  " " +
                                    _vm._s(ctaButton.label) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.trackNotificationBellClick(
                            _vm.notification_unread_count
                          )
                        },
                      },
                    },
                    [
                      !_vm.$userIsAdmin && !_vm.$userIsReportingAdmin
                        ? _c(
                            "router-link",
                            {
                              staticClass: "navbar-notifications",
                              class: {
                                "no-new": _vm.notification_unread_count === 0,
                              },
                              attrs: {
                                tag: "button",
                                to: { name: "notifications.index" },
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-bell" }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.notification_unread_count) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "user-link dropdown",
                      class: {
                        pickstar: _vm.clientName === "Pickstar",
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-toggle",
                          attrs: {
                            "data-toggle": "dropdown",
                            role: "button",
                            "aria-haspopup": "true",
                            "aria-expanded": "false",
                          },
                        },
                        [
                          _c("i", { staticClass: "fa fa-user-circle" }),
                          _vm._v(
                            "\n              Hi, " +
                              _vm._s(_vm.$user.first_name) +
                              "\n\n              "
                          ),
                          _c("i", { staticClass: "fa fa-caret-down" }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("ul", { staticClass: "dropdown-menu" }, [
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "profile.show" } } },
                              [_vm._v("My profile")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "logout" } } },
                              [_vm._v("Logout")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "navbar-toggle offcanvas-toggle",
        attrs: {
          type: "button",
          "data-toggle": "offcanvas",
          "data-target": "#js-bootstrap-offcanvas-nav",
          "aria-label": "Toggle navigation",
        },
      },
      [
        _c("span", { staticClass: "navbar-toggle__line" }),
        _vm._v(" "),
        _c("span", { staticClass: "navbar-toggle__line" }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }